module.exports = __webpack_public_path__ + "img/yookassa-logo.fcccd4ca.svg";